import { render } from "./foroCard.vue?vue&type=template&id=62b91ce4&scoped=true"
import script from "./foroCard.vue?vue&type=script&lang=js"
export * from "./foroCard.vue?vue&type=script&lang=js"

import "./foroCard.vue?vue&type=style&index=0&id=62b91ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b91ce4"]])

export default __exports__